function addElement() {
    var newDiv = document.createElement("div");

    var imgEdge = '<svg class="edge-browser-img"></svg>';
    var imgChrome = '<svg class="chrome-browser-img"></svg>';
    var imgFirefox = '<svg class="firefox-browser-img"></svg>';
    var imgOpera = '<svg class="opera-browser-img"></svg>';
    var imgSafari = '<svg class="safari-browser-img"></svg>';

    if (document.documentMode < 10) {
        imgEdge = '<img src="assets/styles/myminfin/images/icons/1x/logo-browser-edge.png" alt="Edge"></img>';
        imgChrome = '<img src="assets/styles/myminfin/images/icons/1x/logo-browser-chrome.png" alt="Chrome"></img>';;
        imgFirefox = '<img src="assets/styles/myminfin/images/icons/1x/logo-browser-firefox.png" alt="Firefox"></img>';;
        imgOpera = '<img src="assets/styles/myminfin/images/icons/1x/logo-browser-opera.png" alt="Opera"></img>';
        imgSafari = '<img src="assets/styles/myminfin/images/icons/1x/logo-browser-safari.png" alt="Safari"></img>';
    }

    newDiv.innerHTML +=
        '<div class="modal show" tabindex="-1" id="ieDeprecatedModal">' +
        '   <div class="modal-pre-head modal-pre-element">' +
        '       <div>' +
        '           <button onClick="chooseLanguage(\'nl\')" id="nl-button">nl</button>' +
        '           <button onClick="chooseLanguage(\'fr\')" id="fr-button">fr</button>' +
        '           <button onClick="chooseLanguage(\'de\')" id="de-button">de</button>' +
        '       </div>' +
        '   </div>' +
        '   <div id="fr-text">' +
        '       <div class="modal-head modal-element">' +
        '           <div class="title-deprecated-browser">' +
        '               <span>VOTRE NAVIGATEUR N&apos;EST PAS COMPATIBLE AVEC </span>' +
        '               <img src="assets/styles/myminfin/images/MyMinfin_logo.png" alt="MyMinfin"></img>' +
        '           </div>' +
        '           <div>' +
        '               Nous vous conseillons d&apos;utiliser un autre navigateur' +
        '           </div>' +
        '       </div>' +
        '       <div class="modal-body modal-element">' +
        '           <div class="browser-card">' +
        '               <div class="browser-img-container">' +
                            imgEdge +
        '               </div>' +
        '               <div class="browser-link">' +
        '                   <a href="https://www.microsoft.com/fr-fr/edge/" target="_blank">Edge</a>' +
        '               </div>' +
        '           </div>' +
        '           <div class="browser-card">' +
        '               <div class="browser-img-container">' +
                            imgChrome +
        '               </div>' +
        '               <div class="browser-link">' +
        '                   <a href="https://www.google.com/intl/fr/chrome/" target="_blank">Chrome</a>' +
        '               </div>' +
        '           </div>' +
        '           <div class="browser-card">' +
        '               <div class="browser-img-container">' +
                            imgFirefox +
        '               </div>' +
        '               <div class="browser-link">' +
        '                   <a href="https://www.mozilla.org/fr/firefox/new/" target="_blank">Firefox</a>' +
        '               </div>' +
        '           </div>' +
        '           <div class="browser-card">' +
        '               <div class="browser-img-container">' +
                            imgOpera +
        '               </div>' +
        '               <div class="browser-link">' +
        '                   <a href="https://www.opera.com/fr/download" target="_blank">Opera</a>' +
        '               </div>' +
        '           </div>' +
        '           <div class="browser-card">' +
        '               <div class="browser-img-container">' +
                            imgSafari +
        '               </div>' +
        '               <div class="browser-link">' +
        '                   <a href="https://support.apple.com/fr-be/HT204416" target="_blank">Safari</a>' +
        '               </div>' +
        '           </div>' +
        '       </div>' +
        '   </div>' +
        '   <div id="nl-text">' +
        '       <div class="modal-head modal-element">' +
        '           <div class="title-deprecated-browser">' +
        '               <span>UW BROWSER IS NIET COMPATIBEL MET </span>' +
        '               <img src="assets/styles/myminfin/images/MyMinfin_logo.png" alt="MyMinfin"></img>' +
        '           </div>' +
        '           <div>' +
        '               We raden u aan een andere browser te gebruiken' +
        '           </div>' +
        '       </div>' +
        '       <div class="modal-body modal-element">' +
        '           <div class="browser-card">' +
        '               <div class="browser-img-container">' +
                            imgEdge +
        '               </div>' +
        '               <div class="browser-link">' +
        '                   <a href="https://www.microsoft.com/nl-nl/edge/" target="_blank">Edge</a>' +
        '               </div>' +
        '           </div>' +
        '           <div class="browser-card">' +
        '               <div class="browser-img-container">' +
                            imgChrome +
        '               </div>' +
        '               <div class="browser-link">' +
        '                   <a href="https://www.google.com/intl/nl/chrome/" target="_blank">Chrome</a>' +
        '               </div>' +
        '           </div>' +
        '           <div class="browser-card">' +
        '               <div class="browser-img-container">' +
                            imgFirefox +
        '               </div>' +
        '               <div class="browser-link">' +
        '                   <a href="https://www.mozilla.org/nl/firefox/new/" target="_blank">Firefox</a>' +
        '               </div>' +
        '           </div>' +
        '           <div class="browser-card">' +
        '               <div class="browser-img-container">' +
                            imgOpera +
        '               </div>' +
        '               <div class="browser-link">' +
        '                   <a href="https://www.opera.com/nl/download" target="_blank">Opera</a>' +
        '               </div>' +
        '           </div>' +
        '           <div class="browser-card">' +
        '               <div class="browser-img-container">' +
                            imgSafari +
        '               </div>' +
        '               <div class="browser-link">' +
        '                   <a href="https://support.apple.com/nl-be/HT204416" target="_blank">Safari</a>' +
        '               </div>' +
        '           </div>' +
        '       </div>' +
        '   </div>' +
        '   <div id="de-text">' +
        '       <div class="modal-head modal-element">' +
        '           <div class="title-deprecated-browser">' +
        '               <span>IHR BROWSER IST NICHT KOMPATIBEL MIT </span>' +
        '               <img src="assets/styles/myminfin/images/MyMinfin_logo.png" alt="MyMinfin"></img>' +
        '           </div>' +
        '           <div>' +
        '               Wir empfehlen Ihnen einen anderen Browser zu verwenden' +
        '           </div>' +
        '       </div>' +
        '       <div class="modal-body modal-element">' +
        '           <div class="browser-card">' +
        '               <div class="browser-img-container">' +
                            imgEdge +
        '               </div>' +
        '               <div class="browser-link">' +
        '                   <a href="https://www.microsoft.com/de-de/edge/" target="_blank">Edge</a>' +
        '               </div>' +
        '           </div>' +
        '           <div class="browser-card">' +
        '               <div class="browser-img-container">' +
                            imgChrome +
        '               </div>' +
        '               <div class="browser-link">' +
        '                   <a href="https://www.google.com/intl/de/chrome/" target="_blank">Chrome</a>' +
        '               </div>' +
        '           </div>' +
        '           <div class="browser-card">' +
        '               <div class="browser-img-container">' +
                            imgFirefox +
        '               </div>' +
        '               <div class="browser-link">' +
        '                   <a href="https://www.mozilla.org/de/firefox/new/" target="_blank">Firefox</a>' +
        '               </div>' +
        '           </div>' +
        '           <div class="browser-card">' +
        '               <div class="browser-img-container">' +
                            imgOpera +
        '               </div>' +
        '               <div class="browser-link">' +
        '                   <a href="https://www.opera.com/de/download" target="_blank">Opera</a>' +
        '               </div>' +
        '           </div>' +
        '           <div class="browser-card">' +
        '               <div class="browser-img-container">' +
                            imgSafari +
        '               </div>' +
        '               <div class="browser-link">' +
        '                   <a href="https://support.apple.com/de-de/HT204416" target="_blank">Safari</a>' +
        '               </div>' +
        '           </div>' +
        '       </div>' +
        '   </div>' +
        '</div>';
    document.body.appendChild(newDiv);
    chooseLanguage('nl');
}

function chooseLanguage(lang) {
    var arrayLanguages = ['fr', 'nl', 'de'];

    for (var i = 0; i < arrayLanguages.length; i++) {
        var language = arrayLanguages[i];
        var text = document.getElementById(language + '-text');
        text.style.display = 'none'
        var button = document.getElementById(language + '-button');
        button.setAttribute('class', '');

    }

    var chosenLanguage = document.getElementById(lang + '-text');
    chosenLanguage.style.display = 'block';
    var chosenButton = document.getElementById(lang + '-button');
    chosenButton.setAttribute('class', 'active');
}

if (typeof document.documentMode === "number") {
    addElement();
}
